'use client';

import { GTMItemListName } from '@/fo/api/gtm';
import { FeatureProductTileGrouped } from '@/fo/feature/product/tile/grouped';
import { FeatureProductTileMini } from '@/fo/feature/product/tile/mini';
import {
  ProgramType,
  UiProductSectionCarePrograms
} from '@/fo/ui/product/section/care-programs';

interface CareProgramsProps {
  programs: ProgramType[];
  listName: GTMItemListName;
}

export function CarePrograms({ programs, listName }: CareProgramsProps) {
  return (
    <UiProductSectionCarePrograms
      programs={programs}
      renderGrouped={(product) => <FeatureProductTileGrouped data={product} />}
      renderProductTileMini={(product, index) => (
        <FeatureProductTileMini
          key={`${product.id}-${index}`}
          data={product}
          positionIndex={index}
          listName={listName}
        />
      )}
    />
  );
}
